"use client";

import { createContext, useContext, useMemo } from "react";

type HyperliquidConnectionConfig = {
  /**
   * When true, all `useHyperliquidConnection` calls within this provider's subtree
   * skip the Hyperliquid referee-eligibility check on the backend (passes
   * skipEligibility=true to /exchange-account/hyperliquid). Set this from a campaign
   * trading page based on `campaign.disableHyperliquidRefereeCheck`.
   */
  disableEligibilityCheck: boolean;
};

const HyperliquidConnectionConfigContext = createContext<HyperliquidConnectionConfig | undefined>(undefined);

export function HyperliquidConnectionConfigProvider({
  disableEligibilityCheck,
  children,
}: {
  disableEligibilityCheck: boolean;
  children: React.ReactNode;
}) {
  const value = useMemo(() => ({ disableEligibilityCheck }), [disableEligibilityCheck]);
  return (
    <HyperliquidConnectionConfigContext.Provider value={value}>{children}</HyperliquidConnectionConfigContext.Provider>
  );
}

export function useHyperliquidConnectionConfig(): HyperliquidConnectionConfig | undefined {
  return useContext(HyperliquidConnectionConfigContext);
}
